import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ServiceBase} from '../ServiceBase';
import {IHeadLinkTag, IPWAManifestIcon, IManifestProperties, IPWAManifestService} from "./pwa-manifest.service.interface";
import {LINK_REL_APPLE_ICON, LINK_MANIFEST_HEAD_SELECTOR} from "./pwa-manifest-constants";

export class PWAManifestService extends ServiceBase implements IPWAManifestService {

    constructor(services: IServiceFactoryExtended) {
        super(services);
        this._init();
    }

    private get _orbitExtraProperties() {
        return this.services.configuration.startupConfiguration.orbit.extraProperties;
    }

    private _isPwaEnabled() {
        if (!this._orbitExtraProperties.pwaEnabled)
            return false;

        if (!this._orbitExtraProperties.paths.pwaResources) {
            this.services.logger.error("pwaResources is not defined even if pwaEnabled is true");
            return false;
        }

        return true;
    }

    public get manifestUrl(): string | null {
        if (!this._isPwaEnabled())
            return null;

        return this._orbitExtraProperties.paths.pwaResources + '/manifest.json';
    }

    private _init() {
        if (this._isPwaEnabled()) {
            this._setManifestHrefInHead();

            if (this.services.device.os.isIOS) {
                this._initIOS();
            }
        }
    }

    // on IOS device, add link tags for icons from manifest
    private _initIOS() {
        if (this.manifestUrl) {
            this._addManifestIOSIconsInHead();
        } else {
            this.services.logger.error("Couldn't get manifest url");
        }
    }

    private _addManifestIOSIconsInHead(): void {
        this._loadManifestJSON().then((manifestJson) => {
            const manifestIcons = manifestJson.icons || [];
            manifestIcons.forEach(iconInfo => this._addLinkTagToHead(LINK_REL_APPLE_ICON, iconInfo));
        });
    }

    private _addLinkTagToHead(rel: string, iconInfo: IPWAManifestIcon): void {
        const linkDOM = (this.services.dom.createElement('link') as IHeadLinkTag);
        linkDOM.rel = rel;
        linkDOM.href = this._orbitExtraProperties.paths.pwaResources + '/' + iconInfo.src;

        if (iconInfo.sizes) {
            linkDOM.sizes = iconInfo.sizes;
        }

        this.services.dom.head.append(linkDOM);
    }

    private _loadManifestJSON(): Promise<IManifestProperties> {
        return this.services.http.get(this.manifestUrl)
            .catch(err => {
                this.services
                    .logger.error(`Error in loading manifest, manifest url: ${this.manifestUrl}`, err);
                return Promise.reject();
            });
    }

    private _setManifestHrefInHead() {
        const linkTag = (this.services.dom.querySelector(LINK_MANIFEST_HEAD_SELECTOR) as IHeadLinkTag);

        if (linkTag) {
            linkTag.href = this.manifestUrl;
        }
    }
}
